/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/credit_1': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M28 19.354L31.354 16 28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646zM30.646 16L28 18.646v-5.293L30.646 16zM16 1.354L18.646 4h-5.293L16 1.354zM1.354 16L4 13.354v5.292L1.354 16zM16 30.646L13.354 28h5.292L16 30.646zM26 26H6V6h20v20z"/><path pid="1" d="M22.707 15.293L20.414 13l1.544-1.543a.999.999 0 10-1.414-1.414L19 11.586l-2.293-2.293a.999.999 0 00-1.414 0L13 11.586l-1.543-1.543a.999.999 0 10-1.414 1.414L11.586 13l-2.293 2.293a.999.999 0 000 1.414L11.586 19l-1.543 1.543a.999.999 0 101.414 1.414L13 20.414l2.293 2.293a.997.997 0 001.414 0L19 20.414l1.543 1.543a.997.997 0 001.414 0 .999.999 0 000-1.414L20.414 19l2.293-2.293a.999.999 0 000-1.414zM16 20.586L11.414 16 16 11.414 20.586 16 16 20.586z"/>'
  }
})
